import { FC } from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";

import { isIframe } from "@lib/iframe";

interface Props {
  route?: string;
  nonce?: string;
  hideRights?: boolean;
}

const Footer: FC<Props> = ({ hideRights, route }) => {
  const footerInnerHTML = useSelector(
    (state: AppState) => state.requestorConfig.footerInnerHTML
  );
  if (typeof route === "string" && isIframe(route)) {
    return null;
  }
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer-container">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: footerInnerHTML,
        }}
        suppressHydrationWarning
      />
      {!hideRights && (
        <span className="footer-rights">
          © 2001-{currentYear} Developed by CEE Travel Systems
        </span>
      )}
    </div>
  );
};

export default Footer;
